import React, { Component } from "react";
import Layout from "../Layout";
import PropagateLoader from "react-spinners/PropagateLoader";
import BootstrapTable from "react-bootstrap-table-next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faEdit,
  faTrash,
  faEye,
  faFilePdf,
  faQuestionCircle,
  faFileExcel,
  faMinus,
} from "@fortawesome/free-solid-svg-icons";
import {
  Modal,
  Button,
  ButtonGroup,
  Row,
  Col,
  OverlayTrigger,
  Popover,
  Form,
  ButtonToolbar,
} from "react-bootstrap";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ReactTooltip from "react-tooltip";
import Adjunto from "./Adjunto";
import Galeria from "./Galeria";
import ListaAdjuntos from "./ListaAdjuntos";
import ReportePDF from "./ReportePDF";

class F3s extends Component {
  constructor(props) {
    super(props);
    this.GetActionFormat = this.GetActionFormat.bind(this);
    this.state = {
      // Estado relacionado con el modelo
      id: "",
      nombre_de_la_entidad: "",
      fecha_de_publicacion: null,
      nombre_del_titular: "",
      puesto_del_titular: "",
      integrantes_del_organo: [],
      observaciones: "",
      usuario_id: "",
      ambito_id: "",

      // Estados para la ventana modal
      modal: false, // ventana modal generica para modificar y Nuevo cerrada
      modalEliminar: false, //Modal Eliminar
      modalVisualizar: false, //Modal Visualizar
      modalAccion: "", // Acción del boton principal de la ventana modal para el switch
      modalTitle: "", // Titulo para la ventana modal generica
      frm_lista_documentos: [], // Lista de documentos del registro
      frm_archivo: null,
      frm_descripcion_doc: "",
      f3s: [], // Listado de elementos para la tabla
      loading: false,
      noEdit: false,
    };
  }

  componentDidMount = () => {
    this.cargaTabla();
  }
  componentDidUpdate() {
    ReactTooltip.rebuild();
  }

  noEditFnc = async () => {
    let noEdit = false
    let busca = this.props.location.pathname.split("/")
    busca.shift()
    let misAmbitos = localStorage.ambitos.split(",")

    if (busca[2]) {
      let res = null
      res = await axios({
        method: "get",
        url:
          "http://143.198.191.211/api/Ambito/" +
          busca[2] +
          "?api_token=" +
          localStorage.api_token,
        data: {},
      })

      let data = res.data
      if (data.fecha_finalizado != null) {
        noEdit = true
      } else {
        if (misAmbitos.includes(busca[2])) {
          noEdit = false
        } else {
          noEdit = true
        }
      }

      if (localStorage.permisos.includes("admin")) {
        noEdit = false
      }
    }
    if (noEdit) {
      this.setState({ noEdit: true })
    } else {
      this.setState({ noEdit: false })
    }
  }

  cargaTabla = () => {
    this.setState({ loading: true });
    axios({
      method: "get",
      url:
        "http://143.198.191.211/api/F3/ambito/" +
        this.props.match.params.ambito_id +
        "?api_token=" +
        localStorage.api_token,
      data: {},
    }).then((res) => {
      this.setState({ f3s: res.data, loading: false });
    }).finally(() => {
      this.noEditFnc();
    });
  };

  cargaDocumentos = (id) => {
    axios({
      method: "get",
      url:
        "http://143.198.191.211/api/Documento/" +
        this.props.match.params.ambito_id +
        "/3/" +
        id +
        "?api_token=" +
        localStorage.api_token,
      data: {},
    }).then((res) => {
      this.closeModalDocumentos();
      this.setState({ frm_lista_documentos: res.data, loading: false });
    });
  };

  closeModalDocumentos = () => {
    this.setState({ modalDocumentos: false });
  };

  showModalEliminar = () => {
    this.setState({ modalEliminar: true });
  };

  closeModalEliminar = () => {
    this.setState({ modalEliminar: false });
  };

  showModalVisualizar = () => {
    this.setState({ modalVisualizar: true });
  };

  closeModalVisualizar = () => {
    this.setState({ modalVisualizar: false });
  };

  showModal = () => {
    this.setState({ modal: true });
  };

  closeModal = () => {
    this.setState({ modal: false });
  };

  ModalNuevo = () => {
    this.showModal();
    this.setState({
      modalLabel: "Guardar",
      variante: "primary",
      modalAccion: "insert",
      modalTitle: "Registro nuevo",
      id: "",
      nombre_de_la_entidad: "",
      fecha_de_publicacion: null,
      nombre_del_titular: "",
      puesto_del_titular: "",
      integrantes_del_organo: [],
      observaciones: "",
      usuario_id: "",
      ambito_id: "",
    });
  };

  ModalModificar = (row) => {
    this.showModal();
    this.setState({
      modalLabel: "Modificar",
      variante: "warning",
      modalAccion: "update",
      modalTitle: "Modificación",
      id: row.id,
      nombre_de_la_entidad: row.nombre_de_la_entidad,
      fecha_de_publicacion: row.fecha_de_publicacion,
      nombre_del_titular: row.nombre_del_titular,
      puesto_del_titular: row.puesto_del_titular,
      integrantes_del_organo: JSON.parse(row.integrantes_del_organo),
      observaciones: row.observaciones,
      usuario_id: row.usuario_id,
      ambito_id: row.ambito_id,
    });
  };

  ModalVisualizar = (row) => {
    this.cargaDocumentos(row.id);
    this.showModalVisualizar();
    this.setState({
      modalLabel: "Visualizar",
      variante: "warning",
      modalAccion: "view",
      modalTitle: "Visualizar",
      id: row.id,
      nombre_de_la_entidad: row.nombre_de_la_entidad,
      fecha_de_publicacion: row.fecha_de_publicacion,
      nombre_del_titular: row.nombre_del_titular,
      puesto_del_titular: row.puesto_del_titular,
      integrantes_del_organo: JSON.parse(row.integrantes_del_organo),
      observaciones: row.observaciones,
      usuario_id: row.usuario_id,
      ambito_id: row.ambito_id,
    });
  };

  ModalEliminar = (row) => {
    this.showModalEliminar();
    this.setState({
      modalAccion: "delete",
      id: row.id
    });
  };

  ejecutar = (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    switch (this.state.modalAccion) {
      case "update":
        this.actualiza();
        break;
      case "insert":
        this.registra();
        break;
      case "delete":
        this.borra();
        break;
      default:
    }
  };

  registra = () => {
    let data = {
      //Recoger la información para el registro
      nombre_de_la_entidad: this.state.nombre_de_la_entidad,
      fecha_de_publicacion: this.state.fecha_de_publicacion,
      nombre_del_titular: this.state.nombre_del_titular,
      puesto_del_titular: this.state.puesto_del_titular,
      integrantes_del_organo: this.state.integrantes_del_organo,
      observaciones: this.state.observaciones,
      usuario_id: localStorage.id,
      ambito_id: this.props.match.params.ambito_id,
      api_token: localStorage.api_token,
    };
    let config = {};

    axios.post("http://143.198.191.211/api/F3", data, config).then((res) => {
      this.closeModal();
      toast.success(res.data.text, { autoClose: 1000 });
      this.cargaTabla();
      this.setState({ loading: false });
    });
  };

  actualiza = () => {
    let data = {
      //Recoger la información para el registro
      id: this.state.id,
      nombre_de_la_entidad: this.state.nombre_de_la_entidad,
      fecha_de_publicacion: this.state.fecha_de_publicacion,
      nombre_del_titular: this.state.nombre_del_titular,
      puesto_del_titular: this.state.puesto_del_titular,
      integrantes_del_organo: this.state.integrantes_del_organo,
      observaciones: this.state.observaciones,
      usuario_id: localStorage.id,
      ambito_id: this.props.match.params.ambito_id,
      api_token: localStorage.api_token,
    };
    let config = {};

    axios
      .put("http://143.198.191.211/api/F3/" + this.state.id, data, config)
      .then((res) => {
        this.closeModal();
        toast.success(res.data.text, { autoClose: 1000 });
        this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  borra = () => {
    let data = {
      api_token: localStorage.api_token,
    };
    let config = {};
    axios
      .delete(
        "http://143.198.191.211/api/F3/" +
        this.state.id +
        "?api_token=" +
        localStorage.api_token,
        data,
        config
      )
      .then((res) => {
        this.closeModalEliminar();
        toast.success(res.data.text, { autoClose: 1000 });
        this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  onChangeNombreN = (i, e) => {
    let integrantes = [...this.state.integrantes_del_organo]
    let integrante = { ...integrantes[i] }
    integrante.nombre = e.target.value
    integrantes[i] = integrante
    this.setState({ integrantes_del_organo: integrantes })
  };

  onChangeCargoServN = (i, e) => {
    let integrantes = [...this.state.integrantes_del_organo]
    let integrante = { ...integrantes[i] }
    integrante.cargo_serv = e.target.value
    integrantes[i] = integrante
    this.setState({ integrantes_del_organo: integrantes })
  };

  onChangeCargoOrgN = (i, e) => {
    let integrantes = [...this.state.integrantes_del_organo]
    let integrante = { ...integrantes[i] }
    integrante.cargo_org = e.target.value
    integrantes[i] = integrante
    this.setState({ integrantes_del_organo: integrantes })
  };

  onChangeNombreDeLaEntidad = e => {
    this.setState({ nombre_de_la_entidad: e.target.value });
  };

  onChangeFechaDePublicacion = e => {
    this.setState({ fecha_de_publicacion: e.target.value });
  };

  onChangeNombreDelTitular = e => {
    this.setState({ nombre_del_titular: e.target.value });
  };

  onChangePuestoDelTitular = e => {
    this.setState({ puesto_del_titular: e.target.value });
  };

  onChangeObservaciones = e => {
    this.setState({ observaciones: e.target.value });
  };

  onChangeUsuarioId = e => {
    this.setState({ usuario_id: e.target.value });
  };

  onChangeAmbitoId = e => {
    this.setState({ ambito_id: e.target.value });
  };



  onChangefrm_descripcion_doc = (e) => {
    this.setState({ frm_descripcion_doc: e.target.value });
  };

  GetActionFormat = (cell, row, idx, noEdit) => {
    return (
      <div>
        <ButtonGroup size="sm">
          <button
            type="button"
            className="btn btn-outline-info btn-sm"
            size="sm"
            onClick={() => this.ModalVisualizar(row)}
            data-tip="Visualizar"
          >
            <FontAwesomeIcon icon={faEye} size="lg" />
          </button>
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            size="sm"
            onClick={() => this.ModalModificar(row)}
            data-tip="Modificar"
          >
            <FontAwesomeIcon icon={faEdit} size="lg" />
          </button>
          <Adjunto
            ambito_id={this.props.match.params.ambito_id}
            formato={"3"}
            id={row.id}
            disabled={noEdit}
          />
          <button
            type="button"
            className="btn btn-outline-danger btn-sm btn-elimina"
            size="sm"
            onClick={() => this.ModalEliminar(row)}
            data-tip="Eliminar"
            disabled={noEdit}
          >
            <FontAwesomeIcon icon={faTrash} size="lg" />
          </button>
        </ButtonGroup>
      </div>
    );
  };

  addIntegrante = (e) => {
    let integrante = { nombre: "", cargo_serv: "", cargo_org: "" }
    let integrantes = [...this.state.integrantes_del_organo, integrante]
    this.setState({ integrantes_del_organo: integrantes })
  };

  dellIntegrante = (i) => {
    let integrantes = this.state.integrantes_del_organo
    integrantes.splice(i, 1)
    this.setState({ integrantes_del_organo: integrantes })
  };

  render() {
    const columns = [
      {
        dataField: "nombre_de_la_entidad",
        text: "Nombre De La Entidad",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "fecha_de_publicacion",
        text: "Fecha De Publicacion",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "nombre_del_titular",
        text: "Nombre Del Titular",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "puesto_del_titular",
        text: "Puesto Del Titular",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "observaciones",
        text: "Observaciones",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "",
        text: "Acción",
        formatter: this.GetActionFormat,
        formatExtraData: this.state.noEdit,
        headerStyle: () => {
          return {
            width: "140px",
            zIndex: "99",
          };
        },
      },
    ];

    const { SearchBar } = Search;
    const popover = (
      <Popover id="popover-basic">
        <Popover.Title as="h3">Ayuda</Popover.Title>
        <Popover.Content>{this.state.input_tooltip}</Popover.Content>
      </Popover>
    );

    return (
      <Layout>
        <ToastContainer />
        <div
          id="cargando"
          className={this.state.loading ? "parentDisable" : ""}
          width="100%"
        >
          <div className="overlay-box">
            <PropagateLoader
              // css={}
              sizeUnit={"px"}
              size={25}
              color={"#000000"}
              loading={this.state.loading}
            />
          </div>
        </div>

        <div className="container mt-3">
          <div className="row">
            <div className="col">
              <h3 className="d-inline">RELACION DE LOS ORGANISMOS CENTRALIZADOS Y DESCENTRALIZADOS DEL MUNICIPIO</h3>
              <br />
              <small className="text-muted">
                Gestione la información del anexo numero 3 referente
                a relacion de los organismos centralizados y descentralizados del municipio, para el ámbito {this.props.match.params.ambito_id}
              </small>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-12 ">
              <ToolkitProvider
                keyField="id"
                data={this.state.f3s}
                columns={columns}
                bootstrap4
                search
              >
                {(props) => (
                  <div>
                    <div className="row">
                      <div className="col-6">
                        <ButtonToolbar aria-label="Toolbar with button groups">
                          <ButtonGroup
                            className="mr-2"
                            aria-label="First group"
                          >
                            <button
                              className="btn btn-primary btn-nuevo"
                              onClick={this.ModalNuevo}
                              data-tip="Nuevo"
                              disabled={this.state.noEdit}
                            >
                              <FontAwesomeIcon icon={faPlus} /> Nuevo
                            </button>
                          </ButtonGroup>
                          <ButtonGroup
                            className="mr-2"
                            aria-label="Second group"
                          >
                            <ReportePDF ambito_id={this.props.match.params.ambito_id}
                              anexo="3" />
                            <a
                              className="btn btn-primary"
                              data-tip="Descarga Excel"
                              target="_blank"
                              href={
                                "http://143.198.191.211/xlsx/?a=" +
                                this.props.match.params.ambito_id +
                                "&f=3"
                              }
                            >
                              <FontAwesomeIcon icon={faFileExcel} /> Descargar
                              Excel
                            </a>
                          </ButtonGroup>
                        </ButtonToolbar>
                      </div>
                      <div className="col-6 text-right">
                        <SearchBar
                          placeholder="Buscar..."
                          {...props.searchProps}
                          className="self-align-end"
                        />
                      </div>
                    </div>

                    <BootstrapTable
                      {...props.baseProps}
                      pagination={paginationFactory()}
                      hover
                    />
                  </div>
                )}
              </ToolkitProvider>{" "}
            </div>
          </div>
        </div>

        <Modal //***************************Modal para nuevo y modificar
          show={this.state.modal}
          onHide={this.closeModal}
          dialogClassName="modal-90w"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>{this.state.modalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Row>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Nombre De La Entidad:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="nombre_de_la_entidad"
                  value={this.state.nombre_de_la_entidad}
                  onChange={this.onChangeNombreDeLaEntidad}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Fecha De Publicación Del Acuerdo De Creación:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="date"
                  name="fecha_de_publicacion"
                  value={this.state.fecha_de_publicacion}
                  onChange={this.onChangeFechaDePublicacion}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Nombre Del Titular:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="nombre_del_titular"
                  value={this.state.nombre_del_titular}
                  onChange={this.onChangeNombreDelTitular}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Puesto Del Titular:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="puesto_del_titular"
                  value={this.state.puesto_del_titular}
                  onChange={this.onChangePuestoDelTitular}
                />
              </Col>
              <Col xs="12">
                <b>Integrantes del Órgano de Gobierno</b>
              </Col>
              <Col xs="12">
                {(this.state.integrantes_del_organo).map((ele, i) =>
                  <Row key={i}>
                    <Col xs="12" md="5">
                      {i == 0 &&
                        <Form.Label>
                          Nombre Del Integrante:
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "Anotar la fecha de corte de la información." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      <Form.Control
                        type="text"
                        name="nombre"
                        value={ele.nombre}
                        onChange={(e) => this.onChangeNombreN(i, e)}
                      />
                    </Col>
                    <Col xs="12" md="3">
                      {i == 0 &&
                        <Form.Label>
                          Cargo Del Servidor Público:
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "Anotar la fecha de corte de la información." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      <Form.Control
                        type="text"
                        name="cargo_serv"
                        value={ele.cargo_serv}
                        onChange={(e) => this.onChangeCargoServN(i, e)}
                      />
                    </Col>
                    <Col xs="12" md="3">
                      {i == 0 &&
                        <Form.Label>
                          Cargo Dentro Del Órgano De Gobierno:
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "Anotar la fecha de corte de la información." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      <Form.Control
                        type="text"
                        name="cargo_org"
                        value={ele.cargo_org}
                        onChange={(e) => this.onChangeCargoOrgN(i, e)}
                      />
                    </Col>
                    <Col xs="12" md="1">
                      {i == 0 &&
                        <Form.Label>
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "Eliminar Integrante del Órgano de Gobierno" });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      {i == 0 && <br></br>}
                      <button
                        className="btn btn-danger"
                        onClick={(e) => this.dellIntegrante(i, e)}
                        data-tip="Eliminar Integrante del Órgano de Gobierno"
                      >
                        <FontAwesomeIcon icon={faMinus} />
                      </button>
                    </Col>
                  </Row>
                )}
                <br></br>
                <Row className="justify-content-md-center">
                  <Col md="auto">
                    <button
                      className="btn btn-primary btn-add-anidado"
                      onClick={this.addIntegrante}
                      data-tip="Agregar Integrante del Órgano de Gobierno"
                    >
                      <FontAwesomeIcon icon={faPlus} /> Agregar Integrante
                    </button>
                  </Col>
                </Row>
              </Col>
              <Col xs="12" md="12" lg="12">
                <Form.Label>
                  Observaciones:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="observaciones"
                  value={this.state.observaciones}
                  onChange={this.onChangeObservaciones}
                />
              </Col>
            </Form.Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModal}>
              Cancelar
            </Button>
            <Button variant={this.state.variante} onClick={this.ejecutar} className="btn-ejecutar" disabled={this.state.noEdit} >
              {this.state.modalLabel}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal //*******************************Modal para eliminar
          show={this.state.modalEliminar}
          onHide={this.closeModalEliminar}
          size="sm"
          centered
        >
          <Modal.Header>
            <Modal.Title>Eliminar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Seguro que desea eliminar este registro{" "}
            <strong>{this.state.nom_direccion}</strong> ?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModalEliminar}>
              Cancelar
            </Button>
            <Button variant="danger" onClick={this.ejecutar} disabled={this.state.noEdit}>
              Eliminar
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal //*******************************Modal para visializar
          show={this.state.modalVisualizar}
          onHide={this.closeModalVisualizar}
          dialogClassName="modal-90w"
          centered
        >
          <Modal.Header>
            <Modal.Title>Visualizar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Modal.Body className="show-grid">
              <Row>
                <Col xs={12} md={8}>
                  <h5>Datos del Registro</h5>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Nombre De La Entidad:
                    </Col>
                    <Col xs={10}>{this.state.nombre_de_la_entidad}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Fecha De Publicacion:
                    </Col>
                    <Col xs={10}>{this.state.fecha_de_publicacion}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Nombre Del Titular:
                    </Col>
                    <Col xs={10}>{this.state.nombre_del_titular}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Puesto Del Titular:
                    </Col>
                    <Col xs={10}>{this.state.puesto_del_titular}</Col>
                  </Row>
                </Col>
                <Col xs={12} md={4}>
                  <Row>
                    <Col xs={12}>
                      <h5>Archivos Adjuntos</h5>
                    </Col>
                    <Col xs={12}>
                      <ListaAdjuntos archivos={this.state.frm_lista_documentos} cargaDocumentos={this.cargaDocumentos} rowId={this.state.id} />
                    </Col>
                    <Col xs={12}>
                      <Galeria imagenes={this.state.frm_lista_documentos} />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Modal.Body>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModalVisualizar}>
              Cancelar
            </Button>
          </Modal.Footer>
        </Modal>
        <ReactTooltip />
      </Layout >
    );
  }
}

export default F3s;
